import {
  FETCH_AUDIT_ORDERS_REQUEST,
  FETCH_AUDIT_ORDERS_SUCCESS,
  FETCH_AUDIT_ORDERS_FAILURE,
  FETCH_AUDIT_ORDERS_RESET,
} from "../actions/action-type";

const initialState = {
  loading: false,
  orders: [],
  error: null,
  errorDetails: {},
  metadata: {}
};

const ViewManualOrderAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUDIT_ORDERS_REQUEST:
      return { ...state, loading: true, error: false };
    case FETCH_AUDIT_ORDERS_SUCCESS:
      const { orders: newOrders, metadata: newMetadata } = action.payload;
      const { orders: existingOrders } = state;
      let mergedOrders;
      if (existingOrders) {
        mergedOrders = [...existingOrders, ...newOrders];
      } else {
        mergedOrders = newOrders;
      }
      return {
        ...state,
        loading: false,
        orders: mergedOrders,
        metadata: newMetadata,
        error: false,
        errorDetails: {},
      };
    case FETCH_AUDIT_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        orders: [],
        errorDetails: action.payload,
      };
    case FETCH_AUDIT_ORDERS_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default ViewManualOrderAuditReducer;
